import React, { Component } from 'react';
import './BrandList.css';

import idGenerator from '../../idGenerator'

import { base } from '../../base';
import { sortBy, groupBy, keys } from 'lodash';

import Brand from './Brand'

import Grid from '@material-ui/core/Grid'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction'
import Paper from '@material-ui/core/Paper'

class HardwareList extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {
        base.listenToCollection('hardware', {
        context: this,
        then: this.groupData,
        withIds: true
        });
    }

    groupData(data) {
        const brandMap = groupBy(data, (brand) => brand.brand)
        this.setState({
            brandMap
        })
    }


    onSelectBrand = (selectedBrand) => {
        this.setState({
            selectedBrand
         })
    }

    render() {
        const { brandMap, selectedBrand } = this.state
        if (brandMap == null) {
            return <div>Loading...</div>
        }
        return (
            <Grid className="brand-list" container={true} spacing={8}>
                <Grid xs={12} sm={2} item={true} >
                    <Paper className="names">
                        <List >
                            {sortBy(keys(brandMap)).map(brand => (
                                <ListItem
                                    key={idGenerator()}
                                    className="name"
                                    onClick={() => this.onSelectBrand(brand)}
                                    selected={selectedBrand && selectedBrand === brand}
                                >
                                    <ListItemText>{brand}</ListItemText>
                                    <ListItemSecondaryAction className="count">{brandMap[brand].length}</ListItemSecondaryAction>
                                </ListItem>
                            ))}
                        </List>
                    </Paper>
                </Grid>
                {selectedBrand && <Grid xs={12} sm={10} item={true} className="brand-info">
                    <Brand key={idGenerator()} brandItems={brandMap[selectedBrand]} />
                </Grid>}

            </Grid>
        )
    }
}

export default HardwareList;





// WEBPACK FOOTER //
// ./src/components/Hardware/BrandList.js